module.exports = __webpack_public_path__ + "static/media/nao-encontrado.4e491aac.png";